import MobileUser from './MobileUser';

export default MobileUser;
